import React from 'react';
import './SignupFailed.less';
import { TokenService } from '../../services/secureTokenService';
import { useAuth0 } from '@auth0/auth0-react';
import { ReactComponent as Logo } from '../../assets/logo.svg';
import './SignupFailed.less';
import { PERSONAL_EMAIL_SIGNUP_ERROR } from '../../constants/texts';
import {
  getStoredReferrerData,
  buildAuth0UTMParams,
} from '../../utils/utmTracking';

const SignupFailed: React.FC = () => {
  const { loginWithRedirect, logout } = useAuth0();

  // Get UTM data from localStorage before clearing
  const signupData = getStoredReferrerData();

  const handleBackToSignup = () => {
    // Clear all tokens and local storage data, but preserve UTM attribution
    // so it survives into the retry signup flow
    TokenService.clearTokens();
    const savedReferrerData = localStorage.getItem('signup_referrer_data');
    localStorage.clear();
    if (savedReferrerData) {
      localStorage.setItem('signup_referrer_data', savedReferrerData);
    }
    sessionStorage.clear();

    // Logout from Auth0 with federated option to clear all data
    logout({
      logoutParams: {
        federated: true,
      },
    }).then(() => {
      // After logout, redirect to signup
      loginWithRedirect({
        authorizationParams: {
          screen_hint: 'signup',
          // Pass UTM and referrer data to Auth0 for tracking in Actions
          ...buildAuth0UTMParams(signupData),
        },
      });
    });
  };

  return (
    <div id="signup-failed-container">
      <div className="verify-email-icon">
        <Logo />
      </div>
      <h1>Signup Failed</h1>
      <p>{PERSONAL_EMAIL_SIGNUP_ERROR}</p>
      <button onClick={handleBackToSignup} className="not-you-link">
        Back to signup page
      </button>
    </div>
  );
};

export default SignupFailed;
